import { render, staticRenderFns } from "./RiderSettleSetting.vue?vue&type=template&id=132a45b9&scoped=true"
import script from "./RiderSettleSetting.vue?vue&type=script&lang=js"
export * from "./RiderSettleSetting.vue?vue&type=script&lang=js"
import style0 from "./RiderSettleSetting.vue?vue&type=style&index=0&id=132a45b9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a45b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132a45b9')) {
      api.createRecord('132a45b9', component.options)
    } else {
      api.reload('132a45b9', component.options)
    }
    module.hot.accept("./RiderSettleSetting.vue?vue&type=template&id=132a45b9&scoped=true", function () {
      api.rerender('132a45b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryInfo/RiderSettleSetting.vue"
export default component.exports